<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <div class="row d-flex align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0">
                                    <i class=" bx bx-file me-1 text-primary"></i>Test Report
                                </h5>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-3   me-auto">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="search"
                                        ngbTooltip="Search employee course tests by name." placement="top"
                                        container="body">
                                        <i class="bx bx-search-alt"></i>
                                    </span>
                                    <input type="text" class="form-control border-start-0" id="search"
                                        placeholder="Search..." autocomplete="off" [(ngModel)]="searchKeyword">
                                </div>
                            </div>
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="150">Name</th>
                                    <th scope="col" width="100">Code</th>
                                    <th scope="col" width="100">Test Code</th>
                                    <th scope="col" width="200">Test Name</th>
                                    <th scope="col" width="150">Title</th>
                                    <th scope="col" width="120">Passing Score</th>
                                    <th scope="col" width="120"  class="text-center">StartDate</th>
                                    <th scope="col" width="100"  class="text-center">EndDate</th>
                                    <th scope="col" width="100" class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ employeeReport?.name }}</td>
                                    <td>{{ employeeReport?.code }}</td>
                                    <td>{{ employeeReport?.testCode }}</td>
                                    <td>{{ employeeReport?.testName }}</td>
                                    <td>{{ employeeReport?.title }}</td>
                                    <td class="text-center">{{ employeeReport?.passingScore }}</td>
                                    <td class="text-center">{{ employeeReport?. startDate | date:'MMM dd, yyyy'}}</td>
                                    <td class="text-center">{{ employeeReport?. endDate | date:'MMM dd, yyyy'}}</td>
                                    <td class="actions">
                                        <i class="bx bx-show alert-info ms-2" title="View report"
                                            (click)="viewEmployeeReport(employeeReport)">
                                        </i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>